import {
  AllinclusiveIcon,
  AnimationIcon,
  BalconyIcon,
  BallsIcon,
  BathIcon,
  BelorussianSpeakingIcon,
  BerryIcon,
  BikeIcon,
  BilliardIcon,
  BoatIcon,
  BreakfastIcon,
  CanoeIcon,
  ChiefHatIcon,
  CorporativeIcon,
  CosmeticsIcon,
  DiamondIcon,
  DishesIcon,
  DishwasherIcon,
  EnglishSpeakingIcon,
  ExtremeIcon,
  FarmerProductIcon,
  FishingIcon,
  FlatironIcon,
  ForestIcon,
  FridgeIcon,
  FruitsIcon,
  FullboardIcon,
  FurnitureForInfantsIcon,
  GrillIcon,
  HairdryerIcon,
  HalfboardIcon,
  HealthIcon,
  HikingIcon,
  HistoryPlaceIcon,
  HorseIcon,
  HottubIcon,
  HuntingIcon,
  KitchenIcon,
  LocalDishIcon,
  MeetingsIcon,
  MicrowaveIcon,
  MinizooIcon,
  NatureReserveIcon,
  NoAlcoholIcon,
  NoBadMoodIcon,
  NoFireworksIcon,
  NoPetsIcon,
  NoSmokingIcon,
  NoSoundIcon,
  NoSparklersIcon,
  OrganikFoodIcon,
  ParkingIcon,
  PartyhallIcon,
  PatioIcon,
  PetsEnclosureIcon,
  PhoneIcon,
  PierIcon,
  PlateIcon,
  PlaygroundIcon,
  ProectorIcon,
  RestarauntIcon,
  RiverIcon,
  RussianSpeakingIcon,
  SaunaIcon,
  ShopIcon,
  ShowerIcon,
  SmartHouseIcon,
  SportsIcon,
  StarIcon,
  SteamProgramIcon,
  SwimmingPoolIcon,
  TVIcon,
  TeapotIcon,
  TentIcon,
  TerminalIcon,
  TerraceIcon,
  ToiletIcon,
  ToursIcon,
  TowelsIcon,
  TransferIcon,
  UltraAllinclusiveIcon,
  VeganIcon,
  WashingMachineIcon,
  WheelChairIcon,
  WifiIcon,
  WithoutBoardIcon,
  СonditionerIcon,
} from '../assets/features_icons/';

export const FEATURES_LIST = [
  {
    feature_header: 'Удобство и комфорт',
    list: [
      { logo: 'wifi', label: <WifiIcon />, title: 'Бесплатный Wi-Fi' },
      { logo: 'conditioner', label: <СonditionerIcon />, title: 'Кондиционер' },
      { logo: 'tv', label: <TVIcon />, title: 'Телевизор' },
      { logo: 'phone', label: <PhoneIcon />, title: 'Телефон' },
      { logo: 'flatiron', label: <FlatironIcon />, title: 'Утюг' },
      { logo: 'proector', label: <ProectorIcon />, title: 'Проектор' },
      { logo: 'smarthouse', label: <SmartHouseIcon />, title: 'Умный дом' },
    ],
  },
  {
    feature_header: 'Кухня',
    list: [
      { logo: 'kitchen', label: <KitchenIcon />, title: 'Кухня' },
      { logo: 'dishes', label: <DishesIcon />, title: 'Посуда' },
      { logo: 'plate', label: <PlateIcon />, title: 'Плита' },
      { logo: 'fridge', label: <FridgeIcon />, title: 'Холодильник' },
      {
        logo: 'microwave',
        label: <MicrowaveIcon />,
        title: 'Микроволновая печь',
      },
      {
        logo: 'dishwasher',
        label: <DishwasherIcon />,
        title: 'Посудомоечная машина',
      },
      { logo: 'teapot', label: <TeapotIcon />, title: 'Чайник' },
    ],
  },
  {
    feature_header: 'Ванная / туалет',
    list: [
      { logo: 'toilet', label: <ToiletIcon />, title: 'Туалет в доме' },
      { logo: 'shower', label: <ShowerIcon />, title: 'Душевая кабина' },
      { logo: 'bath', label: <BathIcon />, title: 'Ванна' },
      {
        logo: 'washingMachine',
        label: <WashingMachineIcon />,
        title: 'Cтиральная машина',
      },
      { logo: 'hairdryer', label: <HairdryerIcon />, title: 'Фен' },
      { logo: 'towels', label: <TowelsIcon />, title: 'Полотенца' },
      {
        logo: 'cosmetics',
        label: <CosmeticsIcon />,
        title: 'Косметические принадлежности',
      },
    ],
  },
  {
    feature_header: 'Инфраструктура',
    list: [
      { logo: 'parking', label: <ParkingIcon />, title: 'Парковка' },
      { logo: 'terrace', label: <TerraceIcon />, title: 'Терраса' },
      { logo: 'pier', label: <PierIcon />, title: 'Пирс' },
      { logo: 'balcony', label: <BalconyIcon />, title: 'Балкон' },
      { logo: 'patio', label: <PatioIcon />, title: 'Патио' },
      { logo: 'grill', label: <GrillIcon />, title: 'Мангал' },
      { logo: 'sauna', label: <SaunaIcon />, title: 'Баня' },
      { logo: 'hottub', label: <HottubIcon />, title: 'Горячий чан' },
      { logo: 'partyHall', label: <PartyhallIcon />, title: 'Банкетный зал' },
      { logo: 'swimming', label: <SwimmingPoolIcon />, title: 'Бассейн' },
      {
        logo: 'pets',
        label: <PetsEnclosureIcon />,
        title: 'Вольер для домашних животных',
      },
      {
        logo: 'playground',
        label: <PlaygroundIcon />,
        title: 'Детская площадка',
      },
      { logo: 'shop', label: <ShopIcon />, title: 'Магазин' },
      { logo: 'tents', label: <TentIcon />, title: 'Палатки' },
    ],
  },
  {
    feature_header: 'Доступность',
    list: [
      {
        logo: 'wheelChair',
        label: <WheelChairIcon />,
        title: 'Безбарьерная среда',
      },
      { logo: 'transfer', label: <TransferIcon />, title: 'Трансфер' },
      {
        logo: 'furnitureForInfants',
        label: <FurnitureForInfantsIcon />,
        title: 'Детская кроватка',
      },
      {
        logo: 'english',
        label: <EnglishSpeakingIcon />,
        title: 'Владение английским языком',
      },
      {
        logo: 'belorussia',
        label: <BelorussianSpeakingIcon />,
        title: 'Владение белорусским языком',
      },
      {
        logo: 'russia',
        label: <RussianSpeakingIcon />,
        title: 'Владение русским языком',
      },
      {
        logo: 'terminal',
        label: <TerminalIcon />,
        title: 'Платежный терминал',
      },
    ],
  },
  {
    feature_header: 'Развлечения и досуг',
    list: [
      { logo: 'canoe', label: <CanoeIcon />, title: 'Байдарки' },
      { logo: 'bike', label: <BikeIcon />, title: 'Велосипеды' },
      { logo: 'boat', label: <BoatIcon />, title: 'Лодка / катер' },
      { logo: 'billiard', label: <BilliardIcon />, title: 'Бильярд' },
      { logo: 'tours', label: <ToursIcon />, title: 'Экскурсии' },
      { logo: 'berries', label: <BerryIcon />, title: 'Сбор грибов и ягод' },
      { logo: 'balls', label: <BallsIcon />, title: 'Игровые виды спорта' },
      {
        logo: 'animation',
        label: <AnimationIcon />,
        title: 'Анимационная программа',
      },
      {
        logo: 'corporative',
        label: <CorporativeIcon />,
        title: 'Корпоративные мероприятия',
      },
      {
        logo: 'meetings',
        label: <MeetingsIcon />,
        title: 'Мастер-классы / обучение ремёслам',
      },
      { logo: 'zoo', label: <MinizooIcon />, title: 'Мини-зоопарк / ферма' },
      {
        logo: 'health',
        label: <HealthIcon />,
        title: 'Оздоровительные услуги',
      },
      { logo: 'hunting', label: <HuntingIcon />, title: 'Охота' },
      { logo: 'fishing', label: <FishingIcon />, title: 'Рыбалка' },
      { logo: 'hiking', label: <HikingIcon />, title: 'Пешие походы' },
      { logo: 'horses', label: <HorseIcon />, title: 'Прогулки верхом' },
      { logo: 'sports', label: <SportsIcon />, title: 'Спортивная площадка' },
      {
        logo: 'steam',
        label: <SteamProgramIcon />,
        title: 'Программы парения в бане',
      },
      {
        logo: 'extreme',
        label: <ExtremeIcon />,
        title: 'Экстремальный туризм',
      },
    ],
  },
  {
    feature_header: 'Питание',
    list: [
      { logo: 'breakfast', label: <BreakfastIcon />, title: 'Завтрак' },
      { logo: 'halfBoard', label: <HalfboardIcon />, title: 'Полупансион' },
      {
        logo: 'fullBoard',
        label: <FullboardIcon />,
        title: '3-разовое питание',
      },
      {
        logo: 'allInclusive',
        label: <AllinclusiveIcon />,
        title: 'Всё включено',
      },
      {
        logo: 'ultraAllInclusive',
        label: <UltraAllinclusiveIcon />,
        title: 'Ультра всё включено',
      },
      {
        logo: 'withoutBoard',
        label: <WithoutBoardIcon />,
        title: 'Без питания',
      },
      { logo: 'chief', label: <ChiefHatIcon />, title: 'Национальная кухня' },
      { logo: 'localdish', label: <LocalDishIcon />, title: 'Локальная кухня' },
      {
        logo: 'farmer',
        label: <FarmerProductIcon />,
        title: 'Фермерская продукция',
      },
      { logo: 'fruit', label: <FruitsIcon />, title: 'Овощи / фрукты' },
      {
        logo: 'restaraunt',
        label: <RestarauntIcon />,
        title: 'Ресторан / кафе',
      },
      {
        logo: 'organic',
        label: <OrganikFoodIcon />,
        title: 'Органические продукты',
      },
      {
        logo: 'vegan',
        label: <VeganIcon />,
        title: 'Вегетарианское и веганское меню',
      },
    ],
  },
  {
    feature_header: 'Что рядом',
    list: [
      { logo: 'river', label: <RiverIcon />, title: 'Река / озеро' },
      { logo: 'forest', label: <ForestIcon />, title: 'Лес' },
      {
        logo: 'history',
        label: <HistoryPlaceIcon />,
        title: 'Исторические и культурные места',
      },
      {
        logo: 'nature',
        label: <NatureReserveIcon />,
        title: 'Природный заповедник',
      },
    ],
  },
  {
    feature_header: 'Запрещено',
    list: [
      {
        logo: 'noSmoking',
        label: <NoSmokingIcon />,
        title: 'Курение в помещении',
      },
      {
        logo: 'noPets',
        label: <NoPetsIcon />,
        title: 'Пребывание с домашними животными',
      },
      {
        logo: 'noSparlles',
        label: <NoSparklersIcon />,
        title: 'Бенгальские огни в помещении',
      },
      {
        logo: 'noFire',
        label: <NoFireworksIcon />,
        title: 'Пиротехника и салюты',
      },
      { logo: 'noSound', label: <NoSoundIcon />, title: 'Bluetooth-колонки' },
      {
        logo: 'noAlcohol',
        label: <NoAlcoholIcon />,
        title: 'Спиртные напитки',
      },
      {
        logo: 'noBadMood',
        label: <NoBadMoodIcon />,
        title: 'Плохое настроение',
      },
    ],
  },
];
